import React from 'react'
import { BreadcrumbsBox, BreadcrumbsItem } from './styles'
import { Link } from 'react-router-dom'

interface IRiskBreadcrumbsProps {
  screenName: string
}

const RiskBreadcrumbs = (props: IRiskBreadcrumbsProps) => {
  return (
    <BreadcrumbsBox>
      <Link to="/">
        <BreadcrumbsItem>Início</BreadcrumbsItem>
      </Link>
      <BreadcrumbsItem>/</BreadcrumbsItem>
      <Link to="/risk">
        <BreadcrumbsItem>Risco</BreadcrumbsItem>
      </Link>
      <BreadcrumbsItem>/</BreadcrumbsItem>
      <BreadcrumbsItem active>{props.screenName}</BreadcrumbsItem>
    </BreadcrumbsBox>
  )
}

export { RiskBreadcrumbs }
